import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
@Injectable()
export class BaiShengService {
    constructor(
        private httpService: HttpService,
        private AppConfig: AppConfig

    ) { }
    /**登录BS百胜棋牌 */
    loginBaiSheng() {
        let url = AppConfig.GetProdUrl() + "/BaiSheng/LoginBaiSheng";
        return this.httpService.post(url, '');
    }

    /**转账到百胜 */
    transferToBaiSheng(amount: number) {
        let url = AppConfig.GetProdUrl() + "/BaiSheng/TransferToBaiSheng";
        return this.httpService.post(url, { Amount: amount, Type: '0' });
    }
    /**BS百胜棋牌转出 */
    transferFromBaiSheng(amount: number) {
        let url = AppConfig.GetProdUrl() + "/BaiSheng/TransferFromBaiSheng";
        return this.httpService.post(url, { Amount: amount, Type: '1' });
    }
    /**获取BS百胜棋牌余额 */
    getBaiShengBalance() {
        let url = AppConfig.GetProdUrl() + "/BaiSheng/GetBalance";
        return this.httpService.post(url, '');
    }
}


// WEBPACK FOOTER //
// ./src/services/baisheng.service.ts